import { isBefore, startOfDay } from "./_date-fns";
import type { RelativeTimeOptions } from "./relative-time-options";
import type { Time } from "./time";

export function isBeforeToday(time: Time, { now }: RelativeTimeOptions): boolean {
	return isBefore(time, startOfDay(now));
}
